import React, { useContext, useRef, useState } from "react";
import { Form } from "antd";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import decode from "jwt-decode";
import { graphql, useMutation } from "react-apollo";
import { useEffect } from "react";
import { AccountContext } from "../../../context/AccountContext";

const LoginSSO = (props) => {
  const { mutate, history} = props;

  const userContext = useContext(AccountContext);


  const [isError, setError] = useState(null);

  const [resendCode, { data: codeData, loading: codeLoading, error: codeError }] = useMutation(gql`
    mutation($email: String) {
      resendVerifyCode(email: $email) {
        ok
        message
      }
    }
  `);


  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = decodeURIComponent(urlParams.get("token"));
    const email = decodeURIComponent(urlParams.get("email")); // Assuming email is also passed in URL
    if (token && email && token !== "null" && email !== "null") {
        mutate({
            variables: { email: email.trim(), code: token },
          }).then((response) => {
            
            const { ok, token, refreshToken, errors, userPermissions, defaultLandingPage, practiceId } = response.data.loginUser;
            if (ok) {
              localStorage.setItem("token", token);
              localStorage.setItem("refreshToken", refreshToken);
              const { user } = decode(token);
              const { isGlobalAdmin, isPortalAdmin, practices, portals, role } = user;
              const perm = userPermissions.map((per) => per.slug);
    
              userContext.setUserPermission(perm);
             
              if (user) {
                if (user.status === 'Pending' && user.email && user.accountType == 2) {
                    resendCode({ variables: { email : user.email } })
                    .then((result) => {
                      let queryString = `email=${encodeURIComponent(user.email)}&account_type=${user.accountType}`;
                      if (user.memberCompanyIdRequest) {
                          queryString += `&memberCompanyName=${encodeURIComponent(user.memberCompanyIdRequest)}`;
                      }
                      if (user.memberTypeRequest) {
                          queryString += `&utype=${encodeURIComponent(user.memberTypeRequest)}`;
                      }
                      history.push(`/signup-2fa?${queryString}`);
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                } else {
                  if (portals && portals.length > 0) {
                    localStorage.setItem("current_company_id", portals[0].id);
                    localStorage.setItem("current_company", portals[0].slug);
                    if (practices && practices.length > 0) {
                      localStorage.setItem("current_practice_id", practices[0].id);
                      localStorage.setItem("current_practice", practices[0].practiceId);
                    }
                    if (!user.subscriptions && user.accountType == "1") history.push(`/collect-payment`);
                    else {
                      if (defaultLandingPage == "overview") history.push(`/`);
                      else if (defaultLandingPage == "client") history.push(`/${practiceId}/clients`);
                      else history.push(defaultLandingPage);
                    }
                  } else {
                      if (user.status.toLowerCase() == "active" && user.role.length > 0) {
                        history.push("/settings/account");
                      }
                  }
                }
              }
            } else {
                if (errors && errors.length > 0) {
                    setError(errors[0].message);
                }
                userContext.setAccount(null);
                userContext.setProfile(null);
                userContext.setLogoUpdate(null);
                userContext.setUserPermission([]);
    
                localStorage.removeItem("token");
                localStorage.removeItem("refreshToken");
                localStorage.removeItem("currentPractice");

                setTimeout(() => {
                    history.push("/login");
                }, 2000);
            }
          });
    } else {
        history.push("/login");
      }
  
    
  }, [history]);


  return (
    <>
    {!isError && <div>Redirecting...</div>}
    {isError && <div>{isError}</div>}
    </>
  );
};

const loginUserMutation = gql`
  mutation($email: String, $code: String) {
    loginUser(email: $email, code: $code) {
      ok
      token
      defaultLandingPage
      practiceId
      userPermissions {
        id
        slug
      }
      refreshToken
      errors {
        path
        message
      }
    }
  }
`;

export default compose(graphql(loginUserMutation))(Form.create()(LoginSSO));
